import AttributeEditor from '@intercom/embercom-composer/components/attribute-editor';
export default AttributeEditor;
